import { FilesComponent } from './../components/files/files.component';
import { FileDetailComponent } from './../components/files/file-detail.component';
import { ConfirmationComponent } from './../shared/components/modal/confirmation/confirmation.component';
import { FileZoomComponent } from './../components/files/file-zoom.component';
import { AuthGuard } from './../shared/guards/auth.guard';

export const filesRoutes = {
    path: 'files',
    data: {
        breadcrumbs: {
            label: 'Média',
            icon: 'media'
        },
        state: 'files'
    },
    children: [
        {
            path: '',
            component: FilesComponent
        },
        {
            path: ':id',
            component: FileDetailComponent,
            data: {
                breadcrumbs: {
                    label: 'Upravit soubor'
                },
                state: 'pages-media-edit'
            },
            outlet: 'modal'
        },
        {
            path: 'delete/:id',
            component: ConfirmationComponent,
            data: {
                breadcrumbs: {
                    label: 'Smazat soubor'
                },
                state: 'file-delete',
                apiUri: 'files'
            },
            outlet: 'modal'
        },
        {
            path: 'zoom/:id',
            component: FileZoomComponent,
            data: {
                breadcrumbs: {
                    label: 'Zobrazit obrázek'
                },
                state: 'file-zoom'
            },
            outlet: 'modal'
        }
    ],
    canActivate: [AuthGuard]
};
